export default __webpack_public_path__ + "static/media/classify-profile.ccb27804.jpeg";